module.exports = __webpack_public_path__ + "img/mapPin.svg";